import {
  RESET_EMPLOYEE_LIST,
  UPDATE_EMPLOYEE_LIST,
  FETCH_EMPLOYEE_LIST,
  FETCH_EMPLOYEE_LIST_START,
  FETCH_EMPLOYEE_LIST_SUCCESS,
  FETCH_EMPLOYEE_LIST_ERROR,
} from './constants'
import {
  buildAsyncAction,
} from 'containers/Async/actions'

const resetEmployeeList = () => ({ type: RESET_EMPLOYEE_LIST })
const updateEmployeeList = (employees) => ({ type: UPDATE_EMPLOYEE_LIST, employees })
const fetchEmployeeList = (value) => ({ type: FETCH_EMPLOYEE_LIST, value })
const fetchEmployeeListSuccess = (employees) => ({ type: FETCH_EMPLOYEE_LIST_SUCCESS, employees })
const fetchEmployeeListStart = () => ({ type: FETCH_EMPLOYEE_LIST_START })
const fetchEmployeeListError = (error) => ({ type: FETCH_EMPLOYEE_LIST_ERROR, error })
const startFetchEmployeeListAsync = buildAsyncAction(
  FETCH_EMPLOYEE_LIST,
  FETCH_EMPLOYEE_LIST_START,
  [FETCH_EMPLOYEE_LIST_ERROR, FETCH_EMPLOYEE_LIST_SUCCESS]
)

export {
  startFetchEmployeeListAsync,
  resetEmployeeList,
  updateEmployeeList,
  fetchEmployeeList,
  fetchEmployeeListSuccess,
  fetchEmployeeListStart,
  fetchEmployeeListError,
}
